import React from 'react';
import { CheckIcon } from 'lucide-react';
import { summaryRows } from '../data/summary';
import { price, productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SummaryTable() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="summary-title" data-id="element-225" data-mp="o71jkm7hsj9a">
      <div className="mx-auto max-w-4xl px-4" data-id="element-226" data-mp="j7yex2vfcf1u">
        <h2 id="summary-title" className="text-center text-3xl font-extrabold text-white sm:text-4xl" data-id="element-227" data-mp="j53uvcgbow8y">
          Everything included
        </h2>
        <p className="mt-3 text-center text-silver-300" data-id="element-228" data-mp="1bvkqoyet2pzs">
          {productShortName} · {totalVolumes} volumes + {totalBonuses} bonuses ·{' '}
          <b className="text-white" data-id="element-229" data-mp="16uy7bswqciso">{price}</b>
        </p>

        <ul className="mt-10 grid overflow-hidden rounded-xl border border-silver-400/20 bg-navy-800 sm:grid-cols-2" data-id="element-230" data-mp="12vxs0kdgnyaf">
          {summaryRows.map(([feature, detail]) => <li key={feature} className="flex gap-3 border-b border-silver-400/15 p-4 sm:odd:border-r" data-id="element-231" data-mp="3nln3cneyh1yd">
              <span className="metal mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full" data-id="element-232" data-mp="3id5z40xwtdiz">
                <CheckIcon className="h-3.5 w-3.5 text-navy-950" aria-hidden="true" data-id="element-233" data-mp="3nciqmyzq78rw" />
              </span>
              <p data-id="element-234" data-mp="39czlmf27odjt">
                <b className="block text-sm text-white" data-id="element-235" data-mp="39bg64qodq6j3">{feature}</b>
                <span className="text-sm text-silver-300" data-id="element-236" data-mp="3dda1cjft2ibv">{detail}</span>
              </p>
            </li>)}
        </ul>

        <blockquote className="mx-auto mt-10 max-w-2xl rounded-xl border-l-4 border-silver-300 bg-navy-800 px-6 py-5 text-center text-lg font-bold leading-relaxed text-silver-100" data-id="element-237" data-mp="2zlmx9xfmg5ij">
          “The best time to have these materials was at the start of your year. The second-best time is today.”
        </blockquote>
      </div>
    </section>;
}